import { Merchant, Registration } from '@stax-core/types-omni';
import {
  commonFields,
  elavonMapper,
  fdDirectMapper,
  fisPriorityCombinedMapper,
  forteMapper,
  isoMapper,
  priorityMapper,
  tsysDirectMapper,
} from './mapper-util';

export function mapRegistrationToHellosignTemplate(
  registration: Registration,
  template: Merchant['merchant_processor_application'],
) {
  const maps: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    [t in Merchant['merchant_processor_application']]: (
      registration: Registration,
    ) => { [key: string]: any };
  } = {
    iso: isoMapper,
    payfac: fisPriorityCombinedMapper,
    fis_priority_combined: fisPriorityCombinedMapper,
    tsys_direct: tsysDirectMapper,
    fd_direct: fdDirectMapper,
    priority: priorityMapper,
    forte: forteMapper,
    elavon: elavonMapper,
    worldpay_swipe_simple: (_: Registration) => ({}), //TODO: update the mapper
    worldpay_dejavoo: (_: Registration) => ({}), //TODO: update the mapper
  };

  const mapper = maps[template];

  // TODO: This is a temporary solution for Worldpay templates, as those fields are missing from them.
  const commonFieldsObject = commonFields(registration);
  if (template === 'worldpay_swipe_simple' || template === 'worldpay_dejavoo') {
    delete commonFieldsObject['drivers_license_ID'];
    delete commonFieldsObject['issuer_state'];
    delete commonFieldsObject['avg_monthly_volume'];
    delete commonFieldsObject['bank_institution_name'];
  }

  return {
    ...commonFieldsObject,
    ...mapper(registration),
  };
}
export const getHellosignTemplate = (
  type: Merchant['merchant_processor_application'],
) => {
  const map: { [key in Merchant['merchant_processor_application']]: string } = {
    iso:
      process.env.REACT_APP_HELLOSIGN_ISO_APP_TEMPLATE_ID ||
      'ecd9f50e44b68812673ed50c4775228666ea9a76',
    payfac:
      process.env.REACT_APP_HELLOSIGN_PAYFAC_APP_TEMPLATE_ID ||
      '39f799104c085036f584176bbe95b3d09f6a9b7d',
    fis_priority_combined:
      process.env.REACT_APP_HELLOSIGN_FIS_PRIORITY_COMBINED_TEMPLATE_ID ||
      '39f799104c085036f584176bbe95b3d09f6a9b7d',
    tsys_direct:
      process.env.REACT_APP_HELLOSIGN_TSYS_DIRECT_TEMPLATE_ID ||
      '6830709fabc00ef5ece41b0a043173e7bbe36ddf',
    fd_direct:
      process.env.REACT_APP_HELLOSIGN_FD_DIRECT_TEMPLATE_ID ||
      '1f232024f59964efcf3ebb5b16f7fcfa7e2d9319',
    priority:
      process.env.REACT_APP_HELLOSIGN_PRIORITY_APP_TEMPLATE_ID ||
      '14c6bb6abad826e264fa36939f961cb8af882f2c',
    forte:
      process.env.REACT_APP_HELLOSIGN_FORTE_TEMPLATE_ID ||
      'bc810230f19b5061215d6cf83ba7609d107b4e25',
    elavon:
      process.env.REACT_APP_HELLOSIGN_ELAVON_TEMPLATE_ID ||
      '5214f814ad3cce2ca3d6cccac7908019abf444c7',
    worldpay_swipe_simple:
      process.env.REACT_APP_HELLOSIGN_WORLDPAY_SWIPE_SIMPLE_TEMPLATE_ID ||
      'ff8deb315c59652f5699ea7b73c87a4b205a9d11',
    worldpay_dejavoo:
      process.env.REACT_APP_HELLOSIGN_WORLDPAY_DEJAVOO_TEMPLATE_ID ||
      'f1205c7ca4159c166934133e5848798c5242b0f0',
  };
  return map[type];
};
